import {
  standardFocusOutline
} from "./chunk-RNCUEVKR.js";

// src/components/UnstyledButton.tsx
import styled from "@emotion/styled";
var UnstyledButton = styled.button`
  ${standardFocusOutline}
  font-family: ${({ theme }) => theme.typography.fontFamilies.main};
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  /* needed in Safari for some reason */
  font-size: 1rem;
  color: inherit;
  font-weight: inherit;
`;

export {
  UnstyledButton
};
